<template>
    <div class="flex justify-center grid z-[90] place-items-center max-lg:h-[110vh] bg-slate-500/50 fixed items-center top-0 right-0 bottom-0 left-0">
        <div class="max-lg:w-[100%] float z-[100] bg-white p-4 rounded-md w-[100vh] max-lg:h-2/4">
            <svg class="float-right mb-3 pt-0 w-11 h-11 hover:cursor-pointer" @click="$emit('close')" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#006e63">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg> 

            <div class="w-[100%] h-[40vh] overflow-y-auto">
                <div class="flex lg:relative justify-center items-center h-[100%] max-lg:w-screen " v-if="statusLoadingPlanosAtendidos">
                    <LoadingLogo/>
                </div>
                <div v-else>
                    <table class="table-auto w-full ">
                        <thead class="border-b">
                        <tr style="background-color:#006e63">
                            <th class="text-left text-white p-4 leading-relaxed font-medium">
                                Produtos atendidos
                            </th>
                            <th class="text-left text-white p-4 leading-relaxed font-medium">
                                Nº de Protocolo
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="plano in planosSelecionados.planos" :key="plano.nome" class="border-b hover:bg-gray-50">
                            <td class="text-left p-4">
                                {{ plano.nome }} 
                            </td>
                            <td class="text-left p-4">
                                {{ plano.numero_protocolo }} 
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState } from "vuex";
import LoadingLogo from "./loadingLogo.vue";

    export default{
        computed:{
            ...mapState(['planosSelecionados', 'statusLoadingPlanosAtendidos']),
        },

        components:{
            LoadingLogo
        }
    }

</script>